module.exports = __webpack_public_path__ + "img/uk-digestive-diseases-male.c09fc1e3.png";